import React, { type JSX } from 'react';

import {
    Table,
    TableBody,
    TableCell,
    TableRow,
} from '@mui/material';

import { InlineStyles, UserProfileTableHeaderInlineStyles } from '../UserProfileEntityContainerTypeDefs';

import { CommonTitle } from './CommonTitle';
import { TitleWithInfoIcon } from './TitleWithInfoIcon';

type UserProfileEntityTableWrapperProps = {
    title: string;
    children?: React.ReactNode;
    useTitleInfoIcon?: boolean;
    iconTooltipText?: string;
    tableHeaderInlineStyles?: UserProfileTableHeaderInlineStyles;
};

const DEFAULT_TITLE_INLINE_STYLES: InlineStyles = {
    paddingTop: '12px',
    paddingLeft: '24px',
    paddingBottom: '5px'
};

const DEFAULT_CREATE_BUTTON_INLINE_STYLES: InlineStyles = {
    paddingTop: '12px',
    paddingLeft: '24px',
    paddingBottom: '5px'
};

const DEFAULT_TABLE_HEADER_INLINE_STYLES: UserProfileTableHeaderInlineStyles = {
    titleInlineStyles: DEFAULT_TITLE_INLINE_STYLES,
    createButtonInlineStyles: DEFAULT_CREATE_BUTTON_INLINE_STYLES
};

export function UserProfileEntityTableWrapper({
    title,
    children,
    useTitleInfoIcon,
    iconTooltipText,
    tableHeaderInlineStyles
}: Readonly<UserProfileEntityTableWrapperProps>): JSX.Element {
    const tableHeaderAppliedInlineStyles = tableHeaderInlineStyles ?? DEFAULT_TABLE_HEADER_INLINE_STYLES;

    const { titleInlineStyles, createButtonInlineStyles } = tableHeaderAppliedInlineStyles;

    const titleToRender = useTitleInfoIcon ? (
        <TitleWithInfoIcon title={title} iconTooltipText={iconTooltipText}/>
    ) : (<CommonTitle title={title} />);

    return (
        <Table>
            <TableBody>
                <TableRow sx={{ '& td': { border: 0 } }}>
                    <TableCell sx={titleInlineStyles} align="left">
                        {titleToRender}
                    </TableCell>
                    <TableCell align="right" sx={createButtonInlineStyles}>
                        {children}
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
}
